/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './getPreferences.defs.js'
export { main as default } from './getPreferences.defs.js'
